import styled, { css, keyframes } from "styled-components";

import lowPoly from "@/assets/low-poly-grid.png";
import earn from "@/assets/dashboard-home/earn-money.png";
import { styled as muiStyled } from "@mui/material";
import { FutButton } from "@/components/FutButton";
import { customScroll } from "@/styles/globalStyles";
import bgTelegramSectionImg from "./img/bg-telegram.png"

const sectionPadding = '40px';

//deixar por ultimo e animar fotos
export const SectionPictures = styled.section`
  overflow: hidden;
  padding: 10px;
  background: #000;
  min-height: 100vh;
  .ig {
    overflow: hidden;
    white-space: nowrap;
  }
  
  .ig li {
    margin-left: 10px;
    color: rgb(255 255 255 / 32%);
    display: inline-block;
    padding: 0px 10px;
    :before {
      content: '';
      position: absolute;
      width: 10px;
      height: 10px;
      background: rgb(255 255 255 / 32%);
      border-radius: 50px;
      left: -8px;
      top: 4px;
    }
  }
  
  /* Animação do carrossel */
  @keyframes carousel {
    0% {
      transform: translateX(0);
    }
    100% {
      transform: translateX(-100%);
    }
  }
  
  /* Definindo a animação */
  .ig li {
    animation: carousel 10s linear infinite;
  }
  
  /* Se precisar pausar a animação ao passar o mouse */
  .ig:hover li {
    animation-play-state: paused;
  }
  

  h1, p {
    font-family: 'Rubik';
  }

  h1 {
    font-size: 1.4rem;
    font-weight: 600;
  }
  .fut-logo {
    width: 90px;
    margin-bottom: 30px;
  }

  .row-primary {
    display: flex;

    .col-cta {
      padding: 20px;
      width: 100%;
      z-index: 999;
      padding-top: 100px;
      .cta-action {
        margin-top: 30px;
        button {
          margin-top: 26px;
        }
      }

      .cta-primary {
        .text-green {
          color: ${({ theme }) => theme.primary};
          font-weight: bold;
          font-size: 1.4rem;
        }
      }

      .cta-secondary {
        p {
          font-size: 1.2rem;
        }
        b {
          font-weight: 400;
          color: ${({ theme }) => theme.primary};
        }
      }
    }

    .col-images {
      padding: 10px;
      position: relative;

      img {
        transition: ease-in 2s, ease 2s, height 4s;
        opacity: 0.1;
      }

      .active {
        opacity: 0.9;
        transform: scale(1);
      }

      .item1 {
        position: absolute;
        top: -80px;
        right: 132px;
        transform: rotate(3deg);
      }

      .item2 {
        position: absolute;
        top: -62px;
        right: -103px;
      }

      .item3 {
        position: absolute;
        top: 255px;
        right: -41px;
        transform: rotate(2.7deg);
      }
    }
  }

  @media (max-width: 768px) {
    .row-primary {
      /* Styles for smaller screens */
    }
    
    img {
      width: 300px;
    }

    .item3 {
      top: 129px !important;
    }
    .item2 {
      top: -59px !important;
      right: -78px !important;
    }

    .item1 {
      width: 282px;
      right: 69px !important;
      top: -54px !important;
      transform: rotate(4deg) !important;
    }
  }

  @media (min-width: 1385px) {
    .row-primary {
      /* Styles for larger screens */
    }

   

    .item1 {
      /* Additional styles for item1 */
    }

    .item2 {
      /* Additional styles for item2 */
    }

    .item3 {
      /* Additional styles for item3 */
    }
  }
`;

export const SectionCeo = styled.section`
  padding: 0px 20px;
  background: #000;
  text-align: center;
  h1 {
    font-family: "Rubik";
    font-size: 1.6rem;
    font-weight: 700;
  }
  p {
    font-size: 1.2rem;
  }
  b {
    color ${props => props.theme.primary};
  }
  img {
    max-width: 100%;
  }
 .row-primary{
  display: flex;
  justify-content: center;
 }

 .col-cta {
  max-width: 500px;
 }

  @media (max-width: 768px) {
      .row-primary {
        flex-wrap: wrap;
      }
    }
  }
`;

export const SectionFaq = styled.section`
  padding: 20px;
  background: #000;

  .row-primary {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    margin-top: 20px;

    .col-cta {
      flex: 1;

      h1 {
        font-family: "Rubik", sans-serif;
        font-size: 1.6rem;
        color: #fff;
        margin-bottom: 20px; /* Espaçamento abaixo do título */
        font-weight: bold;
       b {
        color: ${props => props.theme.primary}; /* Cor do tema primário */
       }
      }

      p {
        font-size: 1.1rem;
        font-family: "Rubik", sans-serif;
      }

     
      .accordion {
        width: 100%;
        max-width: 600px;
        margin: 20px auto;
        text-align: left;
        h3 {
          font-size: 1.3rem !important;
          font-weight: 400 !important;
          font-family: "Rubik", sans-serif !important;
        }
  
        
        .MuiAccordion-root {
          background: #014b0d;
          width: 100%;
          margin-bottom: 10px;
          svg {
            color: #fff;
            font-size: 20px;
          }
        }

        h3 {
          font-size: 1.5rem;
          margin: 10px 0;
          font-weight: bold; /* Texto da pergunta em negrito */
          color: white; /* Cor branca para o texto da pergunta */
        }

        p {
          font-size: 1rem;
          color: #fff;
        }
      }
    }

    .col-phone {
      /* Estilo da coluna do telefone, se necessário */
    }
  }
`;

const pulseShadow = keyframes`
  0% {
    box-shadow: 0px 9px 10px 0px #008b3a99;
   
  }
  50% {
    box-shadow: rgb(0 139 58) 0px 0px 10px;
    transform: scale(1.01);
  }
  100% {
    box-shadow: 0px 10px 10px 0px #008b3a99;
  }
`;

const clickAnimation = keyframes`
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.2);
    
  }
  100% {
    transform: scale(1);
   
  }
`;

export const StyledButton = styled.button`
  background: linear-gradient(338deg, rgb(0, 203, 84), rgb(0 139 58), rgb(0, 203, 84));
  color: #fff;
  border: none;
  padding: 28px 15px;
  font-size: 1rem;
  border-radius: 18px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: 600;
  letter-spacing: 2px;
  width: 100%;
  max-width: 500px;
  &:hover {
    background-color: #0056b3;
  }

  &:focus {
    outline: none;
  }

  &:active {
    animation: ${clickAnimation} 0.3s linear forwards;
  }

 animation: ${pulseShadow} 2s ease infinite; // Pulso contínuo
`;

export const StyledButtonBordered = styled.button`
  z-index: 999;
  border: 2px solid rgb(0, 191, 80);
  color: rgb(0, 191, 80);
  padding: 30px 20px;
  font-size: 1rem;
  border-radius: 30px;
  cursor: pointer;
  transition: all 0.3s ease 0s;
  /* font-weight: bold; */
  background: none;
  box-shadow: 0px 0px 25px #00c1506b;
  width: 100%;
  transition: ease 400ms;
  &:hover {
    box-shadow: -10px 0px 25px #00bf5026;
    background: #00bf5026;
  }

  &:focus {
    outline: none;
  }

  &:active {
    animation: ${clickAnimation} 0.3s linear forwards;
  }

 animation: ${pulseShadow} 2s ease infinite; // Pulso contínuo
`;

const spinAnimation = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const opacityAnimation = keyframes`
  0% {
    opacity: 0.6;
  }
  50% {
    opacity: 0.2;
  }
  100% {
    opacity: 0.6;
  }
`;
export const StyledImage = styled.img`
  /* Adicionando animações às imagens */
  // animation: ${spinAnimation} 2s linear infinite, ${opacityAnimation} 3s ease-in-out infinite;
`;


export const Footer = styled.footer`
  background-color: #090909;
  color: white;
  padding: 20px;
  text-align: center;
  ul{ 
    display: flex;
    justify-content: center;
    font-size: .8rem;
    font-family: 'Rubik';
    li{
      margin-left: 50px;
    }
  }
  `;

